import React from "react";
import { Box, styled } from "@mui/system";
import { useTokenQueryParams } from "~/features/token/useTokenQueryParams";
import { PdpPage as PdpPageV2 } from "~/features/PDPv2/PdpPage";
import { PdpPage as PdpPageV4 } from "~/features/PDPv4/PdpPage";
import { ContentWrapper } from "~/features/contentWrapper";
import { PreLoaderByApplication } from "~/WhiteLabel/features";
import { useFeature } from "~/features/featureFlag";
import { useCurrentTokenContractDetails } from "~/features/solidityContracts/useCurrentTokenContractDetails";
import ErrorPage from "@/pages/_error";

const StyledSpacer = styled(Box)(({ theme }) => ({
    paddingTop: "92px !important",

    [theme.breakpoints.down(767)]: {
        paddingTop: "16px !important",
    },
}));

export async function getStaticPaths() {
    return { paths: [], fallback: true };
}
export async function getStaticProps(props) {
    const { blockchainId, application, tokenId, tokenContractAddress } =
        props.params;

    return {
        props: {
            blockchainId: +blockchainId,
            application,
            tokenId: +tokenId,
            tokenContractAddress,
        },
        revalidate: 10,
    };
}

export default function ArtworkPage({
    blockchainId: blockchainIdFromGetStaticProps = "",
    tokenId: tokenIdFromGetStaticProps = "",
    tokenContractAddress: tokenContractAddressFromGetStaticProps = "",
}: {
    blockchainId: string;
    tokenId: string;
    tokenContractAddress: string;
}) {
    const tokenQueryParams = useTokenQueryParams();
    const blockchainId =
        +blockchainIdFromGetStaticProps || tokenQueryParams.blockchainId;
    const tokenId = +tokenIdFromGetStaticProps || tokenQueryParams.tokenId;
    const tokenContractAddress =
        tokenContractAddressFromGetStaticProps ||
        tokenQueryParams.tokenContractAddress;
    const isPDPV4Enabled = useFeature("isPDPV4Enabled");

    return (
        <>
            <StyledSpacer />
            {isPDPV4Enabled ? (
                <PdpPageV4
                    blockchainId={+blockchainId}
                    tokenId={+tokenId}
                    tokenContractAddress={tokenContractAddress as string}
                />
            ) : (
                <PdpPageV2
                    blockchainId={+blockchainId}
                    tokenId={+tokenId}
                    tokenContractAddress={tokenContractAddress as string}
                />
            )}
        </>
    );
}

ArtworkPage.pageWrapper = function ArtworkPageWrapper({ Page }) {
    const tokenContractDetails = useCurrentTokenContractDetails();

    if (tokenContractDetails && !tokenContractDetails?.application) {
        return (
            <Box
                component="main"
                style={{
                    minHeight: "100vh",
                }}
            >
                <ErrorPage />
            </Box>
        );
    }

    if (globalThis?.window && !tokenContractDetails) {
        return (
            <Box
                component="main"
                style={{
                    minHeight: "100vh",
                }}
            >
                <ContentWrapper>
                    <PreLoaderByApplication />
                </ContentWrapper>
            </Box>
        );
    }

    return (
        <Box
            component="main"
            style={{
                minHeight: "100vh",
            }}
        >
            <Page />
        </Box>
    );
};
